const getChatAPIHeaders = () => {
  var roleStr = "";
  try {
    var rolesRaw = localStorage.getItem("roles");
    if (rolesRaw) {
      roleStr = JSON.parse(rolesRaw).join(",");
    }
  } catch (e) {
    roleStr = "";
  }
  return {
    "Content-Type": "application/json; charset=utf-8",
    "X-Username": localStorage.getItem("Login_User_Name") || "",
    "X-Access-Token": localStorage.getItem("token") || "",
    "X-Role": roleStr,
  };
};

const CHAT_BASE_URL = process.env.FINANCIAL_ASSISTANT_API_URL;

export function sendChatMessageAPI(question, conversationId, provider) {
  const body = { question, provider: provider || "agent-1" };
  if (conversationId) {
    body.conversation_id = conversationId;
  }
  return fetch(`${CHAT_BASE_URL}/chat`, {
    method: "POST",
    headers: getChatAPIHeaders(),
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((err) => err);
}

export function getConversationsAPI(limit = 50, offset = 0) {
  return fetch(
    `${CHAT_BASE_URL}/conversations?limit=${limit}&offset=${offset}`,
    {
      method: "GET",
      headers: getChatAPIHeaders(),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getConversationAPI(conversationId) {
  return fetch(`${CHAT_BASE_URL}/conversations/${conversationId}`, {
    method: "GET",
    headers: getChatAPIHeaders(),
  })
    .then((res) => res.json())
    .catch((err) => err);
}

export function deleteConversationAPI(conversationId) {
  return fetch(`${CHAT_BASE_URL}/conversations/${conversationId}`, {
    method: "DELETE",
    headers: getChatAPIHeaders(),
  })
    .then((res) => {
      if (res.status === 204) {
        return { success: true };
      }
      return res.json();
    })
    .catch((err) => err);
}

export function renameConversationAPI(conversationId, title) {
  return fetch(`${CHAT_BASE_URL}/conversations/${conversationId}`, {
    method: "PATCH",
    headers: getChatAPIHeaders(),
    body: JSON.stringify({ title }),
  })
    .then((res) => res.json())
    .catch((err) => err);
}

export function exportConversationPdfAPI(conversationId) {
  return fetch(`${CHAT_BASE_URL}/conversations/${conversationId}/export/pdf`, {
    method: "GET",
    headers: getChatAPIHeaders(),
  })
    .then((res) => {
      if (res.status === 200) {
        return res.blob();
      }
      return { status: res.status };
    })
    .catch((err) => err);
}

export function submitFeedbackAPI(messageId, payload) {
  return fetch(`${CHAT_BASE_URL}/messages/${messageId}/feedback`, {
    method: "POST",
    headers: getChatAPIHeaders(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .catch((err) => err);
}
